[
  {
    "code": "AM-AG",
    "name": "Aragatsotn"
  },
  {
    "code": "AM-AR",
    "name": "Ararat"
  },
  {
    "code": "AM-AV",
    "name": "Armavir"
  },
  {
    "code": "AM-ER",
    "name": "Erevan"
  },
  {
    "code": "AM-GR",
    "name": "Gegark'unik'"
  },
  {
    "code": "AM-KT",
    "name": "Kotayk'"
  },
  {
    "code": "AM-LO",
    "name": "Lorri"
  },
  {
    "code": "AM-SU",
    "name": "Syunik'"
  },
  {
    "code": "AM-TV",
    "name": "Tavuš"
  },
  {
    "code": "AM-VD",
    "name": "Vayoc Jor"
  },
  {
    "code": "AM-SH",
    "name": "Širak"
  }
]